/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState, useRef } from "react";
import classnames from "classnames";
import NumberFormat from "react-number-format";
import Skeleton from 'react-loading-skeleton';
import axiosInstance from "../../helpers/axiosInstance";
import Pdf from "react-to-pdf";
import { enGB } from 'date-fns/locale'
import { DateRangePicker, START_DATE, END_DATE } from 'react-nice-dates'
import 'react-nice-dates/build/style.css'
import DownloadLinkContacts from "./DownloadLinkContacts";

// reactstrap components
import {
  Card,
  Container,
  Row,
  Col,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  CardHeader,
  Button,
  Modal,
  Badge,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Table,
  UncontrolledTooltip,
  Alert
} from "reactstrap";
import { normalizeUnits } from "moment";
import { set } from "date-fns";
import { Link } from "react-router-dom";
import { replace, stubTrue } from "lodash";
import { setegid } from "process";
import iconoMasive from "../../assets/img/icons/Icono-Contactos-Inscritos-Gris.png"


function MassiveContactCharge(account) {

  var tabsAux = 0;
  var accountAux = {};
  var stepAux = 0;
  if (account.account != null) {
    accountAux = account.account;
    stepAux = 1;
    tabsAux = 1;
  }

  const [tabToGo, setTabToGo] = useState(0);

  
  const [tabs, setTabs] = useState(tabsAux);  

  const [cancelationModal, setCancelationModal] = useState(false);
  const [notificationModal, setNotificationModal] = useState(false);  
  const [infoModal, setInfoModal] = useState(false);
  const [infoModalArrow, setInfoModalArrow] = useState(false);
  const [iconMasiveContact,setIconMasiveContact] = useState(iconoMasive);
  const [colorMasive,setColorMasive] = useState("text-gray-dark");

  const [errorModal, setErrorModal] = useState(false);
  const [empty, setEmpty] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [isCharging, setIsCharging] = useState(false);

  const [step, setStep] = useState(stepAux);
  const [step2, setStep2] = useState(0);

  const [nameFile, setNameFile] = useState("Selecciona el archivo");
  const [contentFile, setContentFile] = useState("");

  const [bulkId, setBulkId] = useState({});

  const [bulks, setBulks] = useState([]);

  //const [bulkCharged, setBulkCharged] = useState("");

  const [headerBulk, setHeaderBulk] = useState({});

  const [bulk, setBulk] = useState([])

  const [initialDate, setInitialDate] = useState();

  var createReactClass = require('create-react-class');
  const ref = React.createRef();

  async function goBack(tab, isFirst) {
    if (!isFirst) {
      if (tab === 1) {
        await setStep(s => s - 1);
      } else if (tab === 2) {
        await setStep2(s => s - 1);
      }
    } else {
      setCancelationModal(true);
      await setTabToGo(0);
    }
  }


  // Stepper
  function DivStep({ children }) {
    return <>{children}</>
  }

  function Step(props) {
    if (props.current === props.step) {
      return (<li>
        <div className="stepper-content-items">
          <span className="stepper-number-active"></span>
          <span className="stepper-label-active">{props.label}</span>
        </div>
      </li>)
    } else if (props.current > props.step) {
      return (<li>
        <div className="stepper-content-items">
          <img alt="check-copy" class="stepper-number-done" src={require("../../assets/img/bank/check.svg").default} />
          <span className="stepper-label">{props.label}</span>
        </div>
      </li>)
    } else {
      return (<li>
        <div className="stepper-content-items">
          <span className="stepper-number"></span>
          <span className="stepper-label">{props.label}</span>
        </div>
      </li>)
    }
  }

  function Progress(props) {
    const styleProgress = { width: props.current * (100 / (props.size - 1)) + '%' };
    return <div style={styleProgress} className="progress-bar-step"></div>
  }

  function LineStepper(props) {
    var newsTemplate = props.listStep.map(function (item, index) {
      return (
        <Step key={index} current={props.current} step={index} label={item.title} />
      )
    });
    return (
      <>
        <div style={{ position: "relative" }} className="mt-1 m-4">
          <div className="stepper-line">
            <div>
              <Progress current={props.current} size={props.listStep.length}></Progress>
            </div>
          </div>
          <ul className="stepper-content">
            {newsTemplate}
          </ul>
        </div>
      </>
    );
  };

  function DivStepper({ children, ...props }) {
    const childrenArray = React.Children.toArray(children);

    const currentChild = childrenArray[props.step];
    if (props.step != childrenArray.length - 1) {
      return (
        <div {...props}>
          <NavigationButtons tab={props.tab} step={props.step}></NavigationButtons>
          <LineStepper current={props.step} listStep={props.listStep}></LineStepper>
          {currentChild}
        </div>
      );
    } else {
      return (
        <div {...props}>
          <NavigationButtons tab={props.tab} step={props.step}></NavigationButtons>
          <LineStepper current={props.step} listStep={props.listStep}></LineStepper>
          {currentChild}
        </div>
      );
    }
  }

  function NavigationButtons(props) {
    if (props.isOnlyOneStep) {
      return (
        <div style={{ justifyContent: "space-between", display: "flex" }} className="mt-4">
          <button class="btn-icon text-gray-dark btn" onClick={() => setInfoModal(true)}>
            <span class="btn-inner--icon">
              <i class="far fa-question-circle"></i>
            </span>
            <span class="btn-inner--text">Ayuda</span>
          </button>
          <button class="btn-icon text-gray-dark btn" onClick={() => setCancelationModal(true)}>
            <span class="btn-inner--text">Cancelar</span>
            <span class="btn-inner--icon">
              <i class="fas fa-times"></i>
            </span>
          </button>
        </div>
      );
    } else {
      var isFirst = props.step === 0;
      return (
        <div style={{ justifyContent: "space-between", display: "flex" }}>
          <button class="btn-icon text-primary btn" onClick={() => goBack(props.tab, isFirst)}>
            <span class="btn-inner--icon">
              <i class="fas fa-arrow-left"></i>
            </span>
            <span class="btn-inner--text">Volver</span>
          </button>
          <button class="btn-icon text-primary btn" disabled={isFirst} onClick={() => setCancelationModal(true)}>
            <span class="btn-inner--text">Cancelar</span>
            <span class="btn-inner--icon">
              <i class="fas fa-times"></i>
            </span>
          </button>
        </div>
      );
    }
  };

  

  // File
  async function ShowFile() {
    if (window.File && window.FileReader && window.FileList && window.Blob) {
      let baseURL = "";
      var file = document.querySelector('input[type=file]').files[0];
      setNameFile(file.name);

      var reader = new FileReader()

      reader.readAsDataURL(file);
      setIsCharging(false)
      var textFile = /text.*/;
      if (file.type.match(textFile)) {
        reader.onload = function (event) {
          baseURL = reader.result;
          setContentFile(baseURL);
        }
      } else {
        // error diferente .text
      }

    } else {
      // error el navegador no maneja archivos
    }
  }

  

  // subir archivo
  async function UploadFile() {
    var file = document.querySelector('input[type=file]').files[0];
    if(contentFile != empty){
    setIsLoading(true);
    setIsCharging(false);
    //setBulkCharged(bulkId.bulk_id)
    var request = {
      bulk_id: "ARCHC49",
      data: contentFile
    };
    console.log("cargue" + request)
    const response = await axiosInstance().post("/WSGYG39_2/api/transaction/bulk/file", request)
      .catch(err => {
        setErrorModal(true);
        setNameFile("Selecciona el archivo")
        setIsLoading(false);
        return 'err';
      });
    if (response != 'err') {
      //GetBulkId();
      setIsLoading(false);
      setNameFile("Selecciona el archivo");
      setContentFile(empty);
      setIsCharging(false);
      setSuccessModal(true);
    }
  }else{
    setIsCharging(true)
  }
  }


  
 

  function getDateString(d) {
    var dd = d.getDate();
    var mm = d.getMonth() + 1;
    var yyyy = d.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    return yyyy +''+ mm +''+ dd
  }

  
  
  const ejecutasalir=()=>{
    setInfoModal(false);
  }
  const ejecutasalirSuccessModal=()=>{
    setSuccessModal(false);
  }
  const ejecutasalirCancelacion=()=>{
    setCancelationModal(false);
  }
  const ejecutasalirModalArrow=()=>{
    setInfoModalArrow(false);
  }
  const ejecutasalirErrorModal=()=>{
    setErrorModal(false);
  }

  class NavsTransfer extends React.Component {
    toggleModal = state => {
      setNotificationModal(!notificationModal);
    };
    toggleNavs = (e, state, index) => {
      e.preventDefault();
      setTabs(index);
    };

    render() {
      return (
        <>
          <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={cancelationModal}
            toggle={() => setCancelationModal(!cancelationModal)}
          >
            <div className="p-4">
            <div onClick={ejecutasalirCancelacion} style={{width:"100%",display:"flex", justifyContent:"flex-end",alignItems:"center",cursor: "pointer"}}>
                                    <h1 style={{margin:"-15px -10px 0px 0px",fontSize:"20px"}}>
                                        <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
                                          <img
                                            className=""
                                            src={
                                                require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png").default
                                            }/>
                                            </span></h1>
                                </div>
              <div class="my-modal-header">
                <img alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/Cancel.png").default} />
                <div class="header-title">
                  <h5 class="avv-title-bold">¿Quieres salir de la transacción?</h5>
                  <p class="header-subtitle">La información que has ingresado hasta el momento se borrará.</p>
                </div>
              </div>
              <div class="my-modal-footer pt-2">
                <button class="btn bg-gradient-white text-green shadow" type="button" onClick={() => setCancelationModal(false)}> No, volver </button>
                <button class="my-btn btn bg-green text-white shadow" type="button" onClick={() => {
                  setCancelationModal(false);
                  account.cancel();
                       }}> SÍ, SALIR </button>
              </div>
            </div>
          </Modal>
          { <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={errorModal}
            toggle={() => setErrorModal(!errorModal)}
          >
            <div className="p-4">
            <div onClick={ejecutasalirErrorModal} style={{width:"100%",display:"flex", justifyContent:"flex-end",alignItems:"center",cursor: "pointer"}}>
                                    <h1 style={{margin:"-15px -10px 0px 0px",fontSize:"20px"}}>
                                        <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
                                          <img
                                            className=""
                                            src={
                                                require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png").default
                                            }/>
                                            </span></h1>
                                </div>
              <div class="my-modal-header">
                <img style={{width:"100px",height:"100px"}}alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/error-transaction.svg").default} />
                <div class="header-title">
                  <h4 class="avv-title-bold">Error en cargue</h4>
                 <p class="header-subtitle"style={{fontSize:"15px"}}>Por algun motivo el proceso no se pudo realizar, por favor intentelo mas tarde.</p> 
                </div>
              </div>
            </div>
          </Modal> }
          {/* <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={empty}
            toggle={() => setEmpty(!empty)}
          >
            <div className="p-4">
              <div class="my-modal-header">
                <img alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/error-transaction.svg").default} />
                <div class="header-title">
                  <h5 class="avv-title-bold">No hay más registros</h5>
                  <p>No es posible cargar más registros</p>
                </div>
              </div>
            </div>
          </Modal> */}
          <Modal
            className="modal-dialog-centered"
            contentClassName="bg-transparent shadow-none"
            isOpen={isLoading}
          >
             
                  <div tabindex="-1" style={{ position: "relative;" ,  "z-index": "1050" ,  display : "block" , width:"100%", height: "80vh" }}>
                        <div style={{ "text-align": "center", top: "50%", position: "relative"  }}>
                            <img style={{height:"100px", }} src={require("../../assets/img/icons/LoaderIDEA.gif").default}></img>
                        </div>
                        <div class="modal-backdrop fade show"></div>
                    </div>
                
          </Modal>
          <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={successModal}
            toggle={() => setSuccessModal(!successModal)}
          >
            <div className="p-4">
            <div onClick={ejecutasalirSuccessModal} style={{width:"100%",display:"flex", justifyContent:"flex-end",alignItems:"center",cursor: "pointer"}}>
                                    <h1 style={{margin:"-15px -10px 0px 0px",fontSize:"20px"}}>
                                        <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
                                          <img
                                            className=""
                                            src={
                                                require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png").default
                                            }/>
                                            </span></h1>
                                </div>
              <div class="my-modal-header">
                <img style={{width:"100px",height:"100px"}} alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/success-transaction.svg").default} />
                <div class="header-title">
                  <h4 class="avv-title-bold">El proceso de Cargue Masivos de Contactos fue Exitoso</h4>
                  {/* <p class="header-subtitle">A continuación el número de cargue realizado</p>
                  <Alert>Id de cargue: {bulkCharged}</Alert> */}
                </div>
              </div>
            </div>
          </Modal>
          <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={infoModal}
            toggle={() => setInfoModal(!infoModal)}
          >
            <div className="p-4">
            <div onClick={ejecutasalir} style={{width:"100%",display:"flex", justifyContent:"flex-end",alignItems:"center",cursor: "pointer"}}>
                  <h1 style={{margin:"-15px -10px 0px 0px",fontSize:"20px"}}>
                  <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
                                                <img
                                                  className=""
                                                  src={
                                                      require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png").default
                                                  }/>
                                                  </span></h1>
                                      </div>                    
              <div class="my-modal-header">
                <img alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/Cancel.png").default} />
                <div class="header-title">
                  <h5 class="avv-title-bold">Información cargue masivo contactos</h5>
                  <p class="header-subtitle">Aquí podras subir un archivo con las cuentas que quieres asociar. A continuación podrás descargar el archivo.</p>
                  <DownloadLinkContacts href={this.props.excelContactos}>Descargar</DownloadLinkContacts>
                </div>
                {/* <div className="mt-4">
                  <Link class="btn-icon text-primary btn" href="/Formato de Transacciones Masivas.xlsm">
                    <span class="btn-inner--icon">
                      <i class="far fa-question-circle"></i>
                    </span>
                    <span class="btn-inner--text">Ayuda</span>
                  </Link>
                </div> */}
              </div>
            </div>
          </Modal>
          <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={infoModalArrow}
            toggle={() => setInfoModalArrow(!infoModalArrow)}
          >
            <div className="p-4">
            <div onClick={ejecutasalirModalArrow} style={{width:"100%",display:"flex", justifyContent:"flex-end",alignItems:"center",cursor: "pointer"}}>
                                    <h1 style={{margin:"-15px -10px 0px 0px",fontSize:"20px"}}>
                                        <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
                                          <img
                                            className=""
                                            src={
                                                require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png").default
                                            }/>
                                            </span></h1>
                                </div>
              <div class="my-modal-header">
                <img alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/Cancel.png").default} />
                <div class="header-title">
                  <h5 class="avv-title-bold">Información Transacciones masivas</h5>
                  <p class="header-subtitle">Con las flechas de izquierda y derecha te podrás mover hacia atrás y adelante respectivamente.</p>
                </div>
                {/* <div className="mt-4">
                  <Link class="btn-icon text-primary btn" href="/Formato de Transacciones Masivas.xlsm">
                    <span class="btn-inner--icon">
                      <i class="far fa-question-circle"></i>
                    </span>
                    <span class="btn-inner--text">Ayuda</span>
                  </Link>
                </div> */}
              </div>
            </div>
          </Modal>
          <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={notificationModal}
            toggle={() => this.toggleModal("notificationModal")}
          >
            <div className="modal-header">
              <button
                aria-label="Close"
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => this.toggleModal("notificationModal")}
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>
           
          </Modal>
          {/* <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={processModal}
            toggle={() => setProcessModal(!processModal)}
          >
            <div className="p-4">
              <div class="my-modal-header" ref={ref}>
                <img alt="delete-icon" class="my-header-brand-img" src={require("../../assets/img/brand/santander.png").default} />
                <img alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/success-transfer.svg").default} />
                <div class="header-title">
                  <h5 class="avv-title-bold">Tu transferencia a la cuenta {productTwo.numeroCuenta} {productTwo.accountNumber} fue aprobada.</h5>
                  <ul className style={{ listStyle: "none", padding: 0 + 'px', margin: 5 + 'px' }}>
                    <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                      <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Valor</p>
                      <p style={{ textAlign: "right", margin: 0 }}><NumberFormat value={value} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                    </li>
                    <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                      <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Costo</p>
                      <p style={{ textAlign: "right", margin: 0 }}>7750</p>
                    </li>
                    <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                      <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Hacia</p>
                      <div style={{ textAlign: "right", margin: 0 }}>
                        <p style={{ margin: 0 }}>{productTwo.ownerAccount}</p>
                        <p style={{ margin: 0 }}>BBVA</p>
                        <p style={{ margin: 0 }}> Ahorros No. {productTwo.numeroCuenta} {productTwo.accountNumber}</p>
                      </div>
                    </li>
                    <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "15px 0" }}>
                      <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Desde</p>
                      <div style={{ textAlign: "right", margin: 0 }}>
                        <p style={{ margin: 0 }}>Ahorros No. {productOne.accountNumber}</p>
                        <p style={{ margin: 0 }}>Disponible <NumberFormat value={productOne.balance} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="m-2">
                <button class="my-btn btn bg-gradient-primary text-white shadow btn-block" type="button" onClick={() => { setProcessModal(false); setTabs(0) }}> Continuar </button>
                <Pdf targetRef={ref} filename="comprobante.pdf">
                  {({ toPdf }) => (
                    <button class="btn bg-gradient-white text-gray shadow btn-block btn-icon" type="button" onClick={toPdf}>
                      <span class="btn-inner--icon">
                        <i class="fas fa-download"></i>
                      </span>
                      <span class="btn-inner--text">Descargar comprobante</span>
                    </button>
                  )}
                </Pdf>

              </div>
            </div>
          </Modal> */}

          
          <Container className="mb-4" key="container">
            <TabContent activeTab={"tabs" + tabs} key="tab-active">
              <TabPane tabId="tabs0">
                <Container fluid>
                  <div className="text-center m-4">
                    <h2 class="ml-2"> ¿Qué puedes hacer en transacciones masivas de Santander? </h2>
                  </div>
                  <Row className="mt-5 ml-7 mr-7">
                    <Col xl="6" lg="6">
                      <div class="feature ng-star-inserted">
                        <div class="icon">
                          <span class="icon icon-usuario">
                            <i class="fas fa-user"></i>
                          </span>
                        </div>
                        <div class="description">
                          <p ><span class="avv-title-semibold">Cargue de un Archivo </span>con la información perteneciente a las transacciones que quieres realizar para luego ser aprobadas.
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col xl="6" lg="6">
                      <div class="feature ng-star-inserted">
                        <div class="icon">
                          <span class="icon icon-usuario">
                            <i class="fas fa-exchange-alt"></i>
                          </span>
                        </div>
                        <div class="description">
                          <p ><span class="avv-title-semibold">Autorización de la Transacción</span>  masiva previamente creada, ademas de la visualización de sus detalles.
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </TabPane>
              <TabPane tabId="tabs1" className="">
                <Container fluid>
                  <Row>
                    <Col xl="3" lg="2"></Col>
                    <Col xl="6" lg="8">
                      <NavigationButtons isOnlyOneStep={true}></NavigationButtons>
                      <div className="text-center mt-4">
                        <h2 className="ml-2"> Cargue el archivo </h2>
                      </div>
                      <form className="form mt-5">
                        <div className="file-upload-wrapper" data-text={nameFile}>
                          <input name="file-upload-field" type="file" class="file-upload-field" value="" onChange={ShowFile} />
                        </div>
                      </form>
                      <div className="mt-5">
                          <button class="my-btn bg-green text-white btn shadow btn-rounded btn-lg btn-block mr-auto ml-auto" style={{width:"50%"}} onClick={() => { UploadFile() }}> Subir Archivo </button>
                          <Alert isOpen={isCharging}>Debes cargar un archivo</Alert>
                          <Modal
                              className="modal-dialog-centered"
                              contentClassName="bg-transparent shadow-none"
                              isOpen={isLoading}
                              toggle={() => setIsLoading(!isLoading)}
                              >
                                
                                      <div tabindex="-1" style={{ position: "relative;" ,  "z-index": "1050" ,  display : "block" , width:"100%", height: "80vh" }}>
                                            <div style={{ "text-align": "center", top: "50%", position: "relative"  }}>
                                                <img style={{height:"100px", }} src={require("../../assets/img/icons/LoaderIDEA.gif").default}></img>
                                            </div>
                                            <div class="modal-backdrop fade show"></div>
                                        </div>
                                    
                              </Modal>  
                      </div>
                    </Col>
                    <Col xl="3" lg="2"></Col>
                  </Row>
                </Container>
              </TabPane>
              <TabPane tabId="tabs2" className="" key="tab-pane2">
                {/* <Container fluid key="container-tab">
                  <Row key="row-step2">
                    <DateRangePicker
                      startDate={startDate}
                      endDate={endDate}
                      onStartDateChange={setStartDate}
                      onEndDateChange={setEndDate}
                      minimumDate={new Date().setMonth(new Date().getMonth() - 1)}
                      minimumLength={1}
                      format='dd MMM yyyy'
                      locale={enGB}
                    >
                      {({ startDateInputProps, endDateInputProps, focus }) => (
                        <div style={{ justifyContent: "space-between", display: "flex" }}>
                          <input
                            style={{ border: 'none' }}
                            className={'input' + (focus === START_DATE ? ' -focused' : '') + 'input-group-alternative input-group form-control shadow mr-4'}
                            {...startDateInputProps}
                            placeholder='Fecha Inicial'
                          />
                          <input
                            style={{ border: 'none' }}
                            className={'input' + (focus === END_DATE ? ' -focused' : '') + 'input-group-alternative input-group form-control shadow ml-4'}
                            {...endDateInputProps}
                            placeholder='Fecha Final'
                          />
                          <div class="ml-4"><button disabled="" class="my-btn bg-primary text-white btn shadow btn-rounded btn-lg btn-block" onClick={() => GetBulks(endDate, startDate)}>Filtrar</button></div>
                        </div>
                      )}
                    </DateRangePicker>
                    <Col>
                      <div className="mb-0" style={{ justifyContent: "space-between", display: "flex" }}>
                        <a onClick={() => GetBulks1(endDate, startDate,"0")} role="button" aria-haspopup="true" aria-expanded="false" class="btn-icon-only text-primary btn btn- btn-sm">
                          <i class="fas fa-arrow-left"></i>
                        </a>
                        <a onClick={() => GetBulks1(endDate, startDate,"1")} role="button" aria-haspopup="true" aria-expanded="false" class="btn-icon-only text-primary btn btn- btn-sm">
                          <i class="fas fa-arrow-right"></i>
                        </a>
                      </div>
                      
                    </Col>
                    <div className="shadow mt-5 mb-5 card" style={{ width: 100 + '%' }}>
                    <button class="btn-icon text-primary btn" onClick={() => setInfoModalArrow(true)}>
                            <span class="btn-inner--icon">
                              <i class="far fa-question-circle"></i>
                            </span>
                            <span class="btn-inner--text">Ayuda</span>
                        </button>
                      <CardHeader className="border-0 bg-primary">
                        <h3 className="mb-0 text-center text-white">Transacciones Masivas</h3>
                      </CardHeader>
                      <Table className="align-items-center table-flush" responsive>
                        <thead className="thead-light">
                          <tr>
                            <th className="col-md-1 bg-grissantander text-white text-center font-weight-bold h4 p-0">Id</th>
                            <th className="col-md-1 bg-grissantander text-white text-center font-weight-bold h4 p-0">Fecha de <br /> Cargue</th>
                            <th className="col-md-1 bg-grissantander text-white text-center font-weight-bold h4 p-0">Estado</th>
                            <th className="col-md-1 bg-grissantander text-white text-center font-weight-bold h4 p-0">Cantidad de <br /> transacciones</th>
                            <th className="col-md-1 bg-grissantander text-white text-center font-weight-bold h4 p-0">Valor <br /> del lote</th>
                            <th className="col-md-1 bg-grissantander text-white text-center font-weight-bold h4 p-0">Usuario de <br /> creación</th>
                            <th className="col-md-1 bg-grissantander text-white text-center font-weight-bold h4 p-0">Usuario de <br /> aprobación</th>
                            <th className="col-md-1 bg-grissantander text-white text-center font-weight-bold h4 p-0">Tipo de <br /> cargue</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bulks.map((item, index) => {
                            return (
                              <tr>
                                <td>
                                  <a onClick={() => GetBulk(item)} role="button" aria-haspopup="true" aria-expanded="false" class="btn-icon-only text-primary btn btn- btn-sm mr-2 p-0">
                                  <i>{item.bulk_id}</i>
                                  </a>
                                </td>
                                <td className="pr-1">{item.date}</td>
                                <td>
                                  <StatusBulk  status={item.status}></StatusBulk>
                                </td>
                                <td className="pl-5 pr-5">{item.transaction_quantity}</td>
                                <td><NumberFormat value={item.transaction_value} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                                <td>{item.user_creation}</td>
                                <td>{item.user_approval}</td>
                                <td>{item.bulk_type}</td>
                                <td>
                                  {/* <a onClick={() => GetBulk(item)} role="button" aria-haspopup="true" aria-expanded="false" class="btn-icon-only text-primary btn btn- btn-sm">
                                    <i class="fas fa-arrow-right"></i>
                                  </a> */}
                               {/* </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </Row>
                </Container> */}
              </TabPane>
              <TabPane tabId="tabs3">
                {/* <Container>
                  <div className="card p-4 mt-4 shadow row col-md-13">
                    <Row className="mt-2">
                      <div className="col-2"><span style={{ fontWeight: "bold" }}>ID Lote:</span></div>
                      <div className="col-2">{headerBulk.bulk_id}</div>
                      <div className="col-2"><span style={{ fontWeight: "bold" }}>Fecha de Cargue:</span></div>
                      <div className="col-2">{headerBulk.date}</div>
                      <div className="col-1"><span style={{ fontWeight: "bold" }}>Estado:</span></div>
                      <div className="col-3">
                        <StatusBulk status={headerBulk.status}></StatusBulk>
                      </div>
                    </Row>
                    <Row className="mt-2">
                      <div className="col-2"><span style={{ fontWeight: "bold" }}>Cantidad de Transacciones:</span></div>
                      <div className="col-2">{headerBulk.transaction_quantity}</div>
                      <div className="col-2"><span style={{ fontWeight: "bold" }}>Valor Lote:</span></div>
                      <div className="col-2"><NumberFormat value={headerBulk.transaction_value} displayType={'text'} thousandSeparator={true} prefix={'$'} /></div>
                      <div className="col-2"><span style={{ fontWeight: "bold" }}>Tipo de Cargue:</span></div>
                      <div className="col-2">{headerBulk.bulk_type}</div>
                    </Row>
                    <Row className="mt-2">
                      <div className="col-2"><span style={{ fontWeight: "bold" }}>Usuario Cargue:</span></div>
                      <div className="col-2">{headerBulk.user_creation}</div>
                      <div className="col-2"><span style={{ fontWeight: "bold" }}>Usuario Aprobación:</span></div>
                      <div className="col-4">{headerBulk.user_approval}</div>
                    </Row>
                  </div>
                  <Row className="mt-5">
                    <Col><button  class="bg-success text-white btn shadow btn-rounded btn-lg btn-block" disabled={headerBulk.status === '1' || headerBulk.status === '3' || headerBulk.status === '5'} onClick={() => BulkAction('A')}>Aprobar</button></Col>
                    <Col><button  class="bg-danger text-white btn shadow btn-rounded btn-lg btn-block" disabled={headerBulk.status === '1' || headerBulk.status === '3' || headerBulk.status === '5'} onClick={() => BulkAction('R')}>Rechazar</button></Col>
                  </Row>
                  <Row>
                  <Col>
                      <div className="mb-0 mt-5" style={{ justifyContent: "space-between", display: "flex" }}>
                        <a onClick={() => GetBulkPosition("0")} role="button" aria-haspopup="true" aria-expanded="false" class="btn-icon-only text-primary btn btn- btn-sm">
                          <i class="fas fa-arrow-left"></i>
                        </a>
                        <a onClick={() => GetBulkPosition("1")} role="button" aria-haspopup="true" aria-expanded="false" class="btn-icon-only text-primary btn btn- btn-sm">
                          <i class="fas fa-arrow-right"></i>
                        </a>
                      </div>
                    </Col>
                    <div className="shadow mt-5 mb-5 card" style={{ width: 100 + '%' }}>
                    <button class="btn-icon text-primary btn" onClick={() => setInfoModalArrow(true)}>
                            <span class="btn-inner--icon">
                              <i class="far fa-question-circle"></i>
                            </span>
                            <span class="btn-inner--text">Ayuda</span>
                        </button>
                      <CardHeader className="border-0 bg-primary">
                        <h3 className="mb-0 text-center text-white">Transacciones</h3>
                      </CardHeader>
                      <Table className="align-items-center table-flush" responsive>
                        <thead className="thead-light">
                          <tr>
                            <th className="bg-grissantander" scope="col">Tipo<br />Operación </th>
                            <th className="bg-grissantander"  scope="col">Tipo <br /> Producto<br />Origen</th>
                            <th className="bg-grissantander" scope="col">Producto<br />Origen</th>
                            <th className="bg-grissantander"  scope="col">Codigo<br /> Banco <br /> Destino</th>
                            <th className="bg-grissantander"  scope="col">Tipo<br />Producto <br /> Destino</th>
                            <th className="bg-grissantander"  scope="col">Producto<br />Destino</th>
                            <th className="bg-grissantander"  scope="col">Valor</th>
                            <th className="bg-grissantander"  scope="col">Referencia<br /> 1</th>
                            <th className="bg-grissantander"  scope="col">Referencia<br /> 1</th>
                            <th className="bg-grissantander" scope="col">Nombre<br /> Tercero</th>
                            <th className="bg-grissantander" scope="col">Tipo<br />Identificación<br />Tercero</th>
                            <th className="bg-grissantander"  scope="col">Identificación<br />Tercero</th>
                            <th className="bg-grissantander"  scope="col">Digito<br />Chuequeo<br />Tercero</th>
                            <th className="bg-grissantander"  scope="col">NUT</th>
                            <th className="bg-grissantander"  scope="col">Estado</th>
                            <th className="bg-grissantander"  scope="col">Detalle<br /> Respuesta</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bulk.map((item, index) => {
                            return (
                              <tr>
                                <td>{item.operation_Type}</td>
                                <td>{item.source_Product_Type}</td>
                                <td>{item.source_Product_Id}</td>
                                <td>{item.bank_Id}</td>
                                <td>{item.destination_Product_Type}</td>
                                <td>{item.destination_Product_Id}</td>
                                <td><NumberFormat value={item.amount} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                                <td>{item.reference_1}</td>
                                <td>{item.reference_2}</td>
                                <td>{item.tp_Name}</td>
                                <td>{item.tp_Id_Type}</td>
                                <td>{item.tp_Id}</td>
                                <td>{item.tp_checksum}</td>
                                <td>{item.nut}</td>
                                <td>{item.status_Code}</td>
                                <td>{item.status_Detail}</td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </Table>
                    </div>
                  </Row>
                </Container> */}
              </TabPane>
            </TabContent>
          </Container>
        </>

      );
    }
  }

  return (
    <NavsTransfer></NavsTransfer>
  )
}

export default MassiveContactCharge;
